import axios from "./axiosinstance";

const SourceApi = {
  add: (payload) => axios.post("sources/add", payload),
  list: () => axios.get("sources/list"),
  update: (payload) => axios.post("sources/update", payload),
  delete: (payload) => axios.post("sources/delete", payload),
};

export default SourceApi;